import React from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

interface EntityHubVisualizeButtonProps {
  onVisualize: () => void;
  preparing: boolean;
  unavailable: boolean;
  unavailableNote: string;
}

const EntityHubVisualizeButton: React.FC<EntityHubVisualizeButtonProps> = ({
  onVisualize,
  preparing,
  unavailable,
  unavailableNote,
}) => (
  <span
    className='entity-hub-visualize'
    title={unavailable ? unavailableNote : undefined}
  >
    <button
      type='button'
      className='bo-tree-btn entity-hub-visualize-btn'
      onClick={onVisualize}
      disabled={unavailable || preparing}
    >
      <DashboardOutlinedIcon sx={{ fontSize: 16 }} />
      {preparing ? 'Preparing' : 'Visualize'}
    </button>
  </span>
);

export default EntityHubVisualizeButton;
